import { sagwClient } from './clients';
import { MeteringCountDTO, MeteringHistogramDTO, MeteringTimeseriesDTO } from './dtos/metering';
import { meteringTimeseriesDTOToTimeseriesData } from './transformers/metering';

export type MeteringCountParamsBasic = {
  datasource: string;
  startDate: string;
  endDate: string;
};

export type MeteringCountParams = MeteringCountParamsBasic & {
  filterBy?: string;
};

export type MeteringTimeseriesDataParams = MeteringCountParams & {
  attributes: string;
};

export type MeteringHistogramDataParams = MeteringCountParams & {
  attribute: string;
};

export function getMeteringCount(params: MeteringCountParams) {
  return sagwClient.get<MeteringCountDTO>('/b2b/metering/query/count', {
    params
  });
}

export function getMeteringTimeseries(params: MeteringTimeseriesDataParams) {
  return sagwClient
    .get<MeteringTimeseriesDTO>('/b2b/metering/query/timeseries', {
      params
    })
    .then(meteringTimeseriesDTOToTimeseriesData);
}

export function getMeteringHistogram(params: MeteringHistogramDataParams) {
  return sagwClient.get<MeteringHistogramDTO>('/b2b/metering/query/histogram', {
    params
  });
}
